import debugLogger from './debugLogger';

export default function listenToUnhandledRejections() {
  if (process.env.NODE_ENV === 'development') {
    window.addEventListener('unhandledrejection', event => {
      debugLogger.log('--------------------------------');
      debugLogger.log('Global event listener: unhandled rejection');
      debugLogger.log('Reason/Error:', event.detail.reason);
      debugLogger.log('Error Stack:', event.detail.reason.stack);
      debugLogger.log('--------------------------------');
    });
  }
}
